import { render } from "./g-messages-error.vue?vue&type=template&id=567c9e5a&ts=true"
import script from "./g-messages-error.vue?vue&type=script&lang=tsx"
export * from "./g-messages-error.vue?vue&type=script&lang=tsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__